import { delayAsync } from "@eusoft/webapp-core";
import { IClock } from "./abstraction/IClock";

export class PerfClock extends EventTarget implements IClock {

    protected _starTime: number;
    protected _resMs: number;
    
    start(resMs: number) {

        const isStarted = this._starTime != null;

        this._resMs = resMs;

        this._starTime = window.performance.now() / 1000;

        if (resMs > 0 && !isStarted)
            this.tickLoop();

        return this._starTime;
    }

    protected async tickLoop() {

        while (this._starTime) {

            this.onTick(this.getTime());
            await delayAsync(this._resMs);
        }
        console.log("clock stopped");
    }

    stop() {
        this._starTime = undefined;
    }

    getAbsTimeAt(relTime: number) {

        return this.getTime(true) + (relTime - this.getTime(false));
    }

    getTime(absolute = false): number {

        const absTime = window.performance.now() / 1000;
        if (absolute)
            return absTime;
        return absTime - this._starTime;
    }

    setTime(time: number): void {
        if (!this._starTime)
            return;
        const curTime = window.performance.now() / 1000;
        this._starTime = curTime - time;
    }
     
    protected onTick(time: number): void {
        this.dispatchEvent(new CustomEvent("tick", {
            detail: time
        }));
    }

    waitAsync(timeSec: number, abort?: AbortSignal) {

        return new Promise<boolean>((res, rej) => {

            let timerId = setTimeout(() => {

                timerId = undefined;
                res(true);
            }, timeSec * 1000);

            if (abort) {
                abort.onabort = () => {
                    if (timerId !== undefined) {
                        clearTimeout(timerId);
                        timerId = undefined;
                        res(false);
                    }
                }
            }
        });
    }
}
